export default [
  { key: 'disabled', text: 'Disabled', value: 'disabled' },
  { key: 'required', text: 'Required', value: 'required' },
  { key: 'allowed', text: 'Allowed', value: 'allowed' }
];
